import PropertyList from '../components/PropertyList';
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { useState } from "react";
import PropertyFilters from '../components/filtros/PropertyFilters';
import NotFound from './NotFound';

const VALID_OPERATIONS = new Set(['venta', 'alquiler', 'alquiler_temporal', 'alquiler_vacacional']);
const VALID_TYPES = new Set([
  'casa', 'departamento', 'lote', 'galpon', 'local_comercial', 'quinta', 'cabana',
  'ph', 'duplex', 'triplex', 'loft', 'monoambiente', 'finca', 'campo', 'vinedo',
  'oficina', 'consultorio', 'deposito', 'fondo_comercio', 'cochera', 'hotel',
  'apart_hotel', 'complejo_turistico',
]);


function Properties() {

  const { operation, type, department, neighborhood } = useParams();

  const [searchParams] = useSearchParams();
  const query = searchParams.get("q");

  const [filters, setFilters] = useState({
    operation: operation || "",
    type: type || "",
    department: department || "",
    neighborhood: neighborhood || ""
  });

  if ((operation && !VALID_OPERATIONS.has(operation)) || (type && !VALID_TYPES.has(type))) {
    return <NotFound />;
  }

  if (operation === 'alquiler_vacacional') {
    const vacationParams = new URLSearchParams(searchParams);
    if (type) vacationParams.set('type', type);
    if (department) vacationParams.set('department', department);
    if (neighborhood) vacationParams.set('neighborhood', neighborhood);
    return <Navigate replace to={`/vacaciones${vacationParams.size ? `?${vacationParams}` : ''}`} />;
  }

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;

    setFilters(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));

  };

  console.log("PROPERTIES PAGE MONTADO");
  console.log("PARAMS:", { operation, type, department, neighborhood });
  console.log("BUSQUEDA:", query);

  return (
    <div>

      <PropertyFilters
        filters={filters}
        onChange={handleChange}
      />

      <PropertyList
        filters={filters}
        search={query}
        onFilterChange={handleChange}
      />

    </div>
  );

}

export default Properties;
